
var SearchControl = (function () {
  var COPYRIGHT = "(c) Copyright The Australian e-Health Research Centre, CSIRO, 2014",
      limit = 100,
      searchElt,
      messageElt, errorElt,
      resultsElt,
      filter,
      csVersion,
      boost = [],
      selectedConcepts = [],
      listeners = [],
      searchTerm = null,
      request = null;

  const friendlyHttpStatus = {
    '200': 'OK',
    '201': 'Created',
    '202': 'Accepted',
    '203': 'Non-Authoritative Information',
    '204': 'No Content',
    '205': 'Reset Content',
    '206': 'Partial Content',
    '300': 'Multiple Choices',
    '301': 'Moved Permanently',
    '302': 'Found',
    '303': 'See Other',
    '304': 'Not Modified',
    '305': 'Use Proxy',
    '306': 'Unused',
    '307': 'Temporary Redirect',
    '400': 'Bad Request',
    '401': 'Unauthorized',
    '402': 'Payment Required',
    '403': 'Forbidden',
    '404': 'Not Found',
    '405': 'Method Not Allowed',
    '406': 'Not Acceptable',
    '407': 'Proxy Authentication Required',
    '408': 'Request Timeout',
    '409': 'Conflict',
    '410': 'Gone',
    '411': 'Length Required',
    '412': 'Precondition Required',
    '413': 'Request Entry Too Large',
    '414': 'Request-URI Too Long',
    '415': 'Unsupported Media Type',
    '416': 'Requested Range Not Satisfiable',
    '417': 'Expectation Failed',
    '418': 'I\'m a teapot',
    '422': 'Unprocessable Entity',
    '500': 'Internal Server Error',
    '501': 'Not Implemented',
    '502': 'Bad Gateway',
    '503': 'Service Unavailable',
    '504': 'Gateway Timeout',
    '505': 'HTTP Version Not Supported',
  };

  function idForConcept(concept) {
    return concept ? concept.s.replace(/\W/g, '_')+'_'+(concept.v||'').replace(/\W/g, '_')+'_'+concept.c.replace(/\W/g, '_') : undefined;
  }

  return {
    settings: {
      defaultSearch: undefined,
      inputId: "ontosearch",
      messageId: "#searchmsg",
      errorId: "#messages",
      resultsId: ".resultlist",
    },

    init: function () {
      var s = this.settings;

      Endpoint.addListener(function (systemUri, version) {
        // check startsWith
        if (systemUri === "http://snomed.info/sct") {
          boost =["900000000000441003,-0.5"];
        } else {
          boost = [];
        }
      });

      searchElt = document.getElementById(s.inputId);
      messageElt = d3.select(s.messageId);
      errorElt = d3.select(s.errorId);

      if ('onsearch' in searchElt) {
        searchElt.onsearch = onSearch;
      } else if ('oninput' in searchElt) {
        searchElt.oninput = onSearch;
      } else {
        searchElt.change = onSearch;
        alert("Search may not work (or may not work well) on this browser.");
      }

      resultsElt = d3.select(s.resultsId);

      resultsElt
        .on("keydown", function() {
          var idx, elts;
          switch (d3.event.keyCode) {
          case 38:	// up
            elts = resultsElt.selectAll("li")[0];
            if (selectedConcepts.length) {
              idx = elts.map(e => e.classList.contains('selected')).indexOf(true) - 1;
            }
            break;
          case 40:	// down
            elts = resultsElt.selectAll("li")[0];
            if (selectedConcepts.length == 0) {
              idx = 0;
            } else {
              idx = elts.map(e => e.classList.contains('selected')).lastIndexOf(true) + 1;
            }
            break;
          default:
            return;
          };

          if (idx >= 0 && idx < elts.length) {
            var z = this.getBoundingClientRect(),
                r = elts[idx].getBoundingClientRect();

            // check currently visible
            if (r.bottom<(z.bottom-15) && r.top>z.top) {
              d3.event.preventDefault();
            }

            HistoryManager.userAction(selectListItem)(elts[idx])
          };
        })
        ;

      if (s.defaultSearch) {
        searchElt.value = s.defaultSearch;
      }

    },

    initSearch: function(text) {
      this.settings.defaultSearch = text;
    },

    selectConcepts: function(concepts) {
      var s = this.settings,
      resultsElt = d3.select(s.resultsId),
      elts = resultsElt.selectAll("li"),
      found = false;
      
      const ids = concepts.map(c => idForConcept(c));

      selectedConcepts.length = 0;
      Array.prototype.push.apply(selectedConcepts, concepts);

      elts.classed('selected', function(d) {return ids.indexOf(d.id) >= 0; })
    },

    setSearch: function (text, force) {
      if (searchElt.value !== text || force) {
        searchElt.value = text;
        this.update();
      }
    },

    setFilter: function(f,v) {
      filter = f;
      csVersion = v;
    },

    getFilter: function() {
      return filter;
    },

    update: function () {
      onSearch(null);
    },

    addListener: function (listener) { listeners.push(listener); },
  };

  function onSearch(input) {
    var value = (input && input.srcElement) ? input.srcElement.value : searchElt.value;
    searchTerm = value;

    errorElt.text('');

    if (request) {
      // console.log("cancelling request");
      request.abort();
      request = null;
    }

    if (!filter || (Array.isArray(filter) && !filter.length)) {
      updateResults([]);
      return;
    }

    request = Endpoint.findConceptsByTermPrefixes({
        terms: value,
        fields: ["code", "display", "fullySpecifiedName", "active"],
        systemVersion: csVersion,
        includeDesignations: true,
        filter: filter,
        boost: boost,
        limit: limit,
      },
      function(error, result) {
        if (value !== searchTerm) {
          // stale result
          console.log('stale search result', value, searchTerm);
          return;
        } else {
          request = null;
        }

        if (error && error.status < 500) {
          updateResults([]);

          if (!error.body) {
            console.log(error, 'No response', friendlyHttpStatus[error.status]);
            console.log(error.message);
            errorElt.text(error.status + '  ' + friendlyHttpStatus[error.status]);
          } else {
            var response = error.body;
            console.log(error, response);
            if (response.issue) {
              errorElt.text(response.issue[0].diagnostics);
            }
          }
          return;
        }

        var rows = (result||{}).contains || [],
            total = (result||{}).total,
            versions = {};

        // extract CodeSystem version information
        ((result||{}).parameter || []).forEach(function (p) {
          if ("version" === p.name) {
            var parts = p.valueUri.split('?version=');
            if (parts.length > 1) {
              versions[parts[0]] = decodeURIComponent(parts[1]);
            }
          }
        });

        var actives = [], inactives = [];

        var tokens = (value || "").split(/ +/);
        if (!value) {
          rows.sort(function (a,b) { return a.display < b.display ? -1 : (b.display < a.display ? 1 : 0); });
        }
        rows.forEach(function(r) {
          if (r.designation) {
            const fsn = {};
            r.designation.forEach(function (t) {
              if (t.use && t.use.code === '900000000000003001' && t.use.system === 'http://snomed.info/sct' && t.value.endsWith(')')) {
                fsn[t.language] = t.value;
              }
            });
            const availLang = new locale.Locales(Object.keys(fsn));
            const userLang = new locale.Locales(navigator.language);
            const bestMatch = userLang.best(availLang);

            r.fullySpecifiedName = fsn[bestMatch.toString()] || fsn[Object.keys(fsn)[0]];
          }
          var active = isActive(r);
          const version = r.version || versions[r.system];
          const isAU = version.indexOf('/32506021000036107') > 0;
          const semanticTag = (r.fullySpecifiedName||"").replace(/^.*[(]/,'(');
          (true === active ? actives : inactives).push(
            { id: idForConcept({s: r.system, v: r.version || versions[r.system], c: r.code}),
              code: r.code,
              system: r.system,
              version: version,
              active: active,
              display: Endpoint.trimLabel(r.display, r.code),
              cat: isAU ? mapCategory(semanticTag) : semanticTag,
            }
        )});
        updateResults(actives.concat(inactives), total, tokens);
      });
  }

  function isActive(r) {
    return (r.extension || []).reduce(
      function (active, ext) {
        if ('http://ontoserver.csiro.au/profiles/expansion' === ext.url) {
          return ext.extension.reduce(
            function (active, ext) {
              return 'inactive' === ext.url ? !ext.valueBoolean : active;
            }, active);
        }
        return active;
      },
      true
    );
  }

  function mapCategory(label) {
    switch (label) {
      case '(trade product)':
        return '(TP)';
      case '(trade product pack)':
        return '(TPP)';
      case '(containered trade product pack)':
        return '(CTPP)';
      case '(trade product unit of use)':
        return '(TPUU)';
      case '(medicinal product)':
        return '(MP)';
      case '(medicinal product pack)':
        return '(MPP)';
      case '(medicinal product unit of use)':
        return '(MPUU)';
      default:
        return label;
    }
  }

  function selectListItem(item) {
    if ("LI" == item.nodeName) {
      var concept, id;

      d3.select(item)
        .each(function (d) {
          concept = {s: d.system, v: d.version, c: d.code};
          id = idForConcept(concept);
        });

      if (d3.event.ctrlKey || d3.event.metaKey) { // Toggle
        const idx = selectedConcepts.map(idForConcept).indexOf(id);
        if (idx >= 0) { // already selected
          selectedConcepts.splice(idx, 1);
        } else {
          selectedConcepts.push(concept);
        }
      } else {  // Clear and add
        selectedConcepts.length = 0;  // clear
        selectedConcepts.push(concept);
      }

      listeners.forEach(function (callback) {
        try {
          callback(selectedConcepts);
        } catch (err) {
          console.log(err);
        }
      });
    }
    else {
      // should not get here
      console.log(item);
    }
  }

  // See https://github.com/benjamingr/RegExp.escape and http://stackoverflow.com/a/9310752/1865099
  function regexEscape(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  };

  function updateResults(concepts, total, tokens) {
    if (total < 0) {
      messageElt.text("");
    } else {
      messageElt.text(total > limit ? (concepts.length + " of " + total + " matches") : total + " matches");
    }

    // remove old rows so that the li elements are added in the correct order
    resultsElt.selectAll("li").remove();
    var results = resultsElt.selectAll("li")
                    .data(concepts, function(d,i) { return d.id; });

    const ids = selectedConcepts.map(c => idForConcept(c));

    results
      .enter()
        .append("li")
        .attr('id', function(d) { return d.id; })
        .attr('data-code', function(d) { return d.code; })
        .attr('data-system', function(d) { return d.system; })
        .attr('data-version', function(d) { return d.version; })
        .classed('inactive', function(d) { return true !== d.active; })
        .classed('noselect', true)
        .classed('selected', function(d) {return ids.indexOf(d.id) >= 0; })
        .attr("draggable", true)
        .on("dragstart", function (d) { d3.event.dataTransfer.setData('text', d.code+" |"+d.display+"|"); })
        .on("click", function () { HistoryManager.userAction(selectListItem)(this); })
        //.text(function(d) {return d.display;});
        .html(function(d) {
          var pattern = '('
                + tokens
                    .map(function (tok) { return tok.replace(/\W/g, ''); })
                    .map(regexEscape)
                    .join('|')
                + ')',
              highlighted = d.display.replace(new RegExp(pattern, 'gi'), '</span>$1<span class="unmatched">');

          return '<span class="unmatched">'
            +highlighted
//            +tokens.reduce(function (base, val) {
//              val = val.replace(/\W/g, '');
//              return val ? base.replace(new RegExp("("+val+")","gi"), "</b>$1<b>") : base;
//            }, d.display)
            +'</span><span style="float:right;">'+d.cat+'</span>';
        });

    results.exit().remove();
  }

}());

